exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-details-price .price > div {\n  -ms-flex-direction: column;\n      flex-direction: column;\n  row-gap: unset;\n}\n.product-details-price .price > div .price-original {\n    font-size: 16px;\n}\n", ""]);

// exports
